import { useState } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { DeepLinkTarget } from './header/SectionSummary.types';
import { MedicalProfileModal } from './MedicalProfileModal';

type MedicalProfileModalOpenerRenderProps = {
   readonly openModal: VoidFunction;
   readonly openModalWithTarget: (target: DeepLinkTarget) => void;
};

type MedicalProfileModalOpenerProps = {
   readonly patientId: number;
   readonly readonly: boolean;
   readonly children: (renderProps: MedicalProfileModalOpenerRenderProps) => JSX.Element;
};

export const MedicalProfileModalOpener = (props: MedicalProfileModalOpenerProps): JSX.Element => {
   const [{ setFalse: closeModal, setTrue: showModal }, modalOpened] = useBoolean(false);
   const [target, setTarget] = useState<DeepLinkTarget | null>(null);

   const openModal = (): void => {
      setTarget(null);
      showModal();
   };

   const openModalWithTarget = (nextTarget: DeepLinkTarget): void => {
      setTarget(nextTarget);
      showModal();
   };

   return (
      <>
         {props.children({ openModal: openModal, openModalWithTarget: openModalWithTarget })}

         {modalOpened ? (
            <MedicalProfileModal
               patientId={props.patientId}
               readonly={props.readonly}
               initialTarget={target}
               onClose={closeModal}
            />
         ) : null}
      </>
   );
};
